import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, setupI18n } from '@greenrinse/ui';
import '@greenrinse/ui/tokens.css';
import App from './App';

setupI18n();

const OPERATOR_ROLES = ['SuperAdmin', 'RegionalManager', 'OperationsSupervisor', 'Finance', 'TeamLead'] as const;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <AuthProvider allowedRoles={[...OPERATOR_ROLES]}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
